import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';
// eslint-disable-next-line import/prefer-default-export
export function useSentry(Vue, router) {
    const env = process.env.VUE_APP_ENV
    if (env !== 'dev') { // 关键代码，不处理开发环境监控
        Sentry.init({
            Vue,
            environment: env, // 关键代码，利用环境做标识
            dsn: "https://376c7e3fff54449d933aca0193d84448@sentry.yunlizhi.cn/6",
            integrations: [
                new BrowserTracing({
                    routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                    tracingOrigins: ["localhost", /^\//],
                }),
            ],
            // Set tracesSampleRate to 1.0 to capture 100%
            // of transactions for performance monitoring.
            // We recommend adjusting this value in production
            tracesSampleRate: 1.0,
            logErrors: true, // 关键代码， 必须写true，否则项目vue日志会无法抛出
        });
    }
}
